export default __webpack_public_path__ + "static/media/zerodha.12b442b9.svg";